import { RichTextBlock } from 'prismic-reactjs';
import gql from 'graphql-tag';
import { IEmbed, IImage, ILink } from 'utils/types';
import { IBaseSlice, SliceTypes } from '..';
import { PrismicEmbed, PrismicImage, PrismicLink } from '../../utils/PrismicTypes';
import { parser } from '../../utils/parsers';

export interface IStaggeredBlocks extends IBaseSlice {
  style: string;
  direction: string;
  items: Array<{
    image: IImage;
    tagline: string;
    title: string;
    text: RichTextBlock[];
    caption: string;
    label: string;
    link: ILink;
    secondLabel: string;
    secondLink: ILink;
    video: ILink;
    embed: IEmbed;
  }>;
}

export const fragment = (name: string, type: string, fragmentName: string) => gql`
  fragment ${fragmentName || name} on ${type} {
    ... on ${type}${name} {
      type
      primary {
        slice_style
        slice_direction
      }
      fields {
        item_image
        item_tagline
        item_title
        item_text
        item_caption
        item_label
        item_link {
          ...Link
        }
        item_secondlabel
        item_secondlink {
          ...Link
        }
        item_video {
          ...Link
        }
        item_embed
      }
    }
  }
`;

type Props = {
  primary: { slice_style: string; slice_direction: string };
  fields: Array<{
    item_image: PrismicImage;
    item_tagline: RichTextBlock[];
    item_title: RichTextBlock[];
    item_text: RichTextBlock[];
    item_caption: RichTextBlock[];
    item_label: RichTextBlock[];
    item_link: PrismicLink;
    item_second_label: RichTextBlock[];
    item_second_link: PrismicLink;
    item_video: PrismicLink;
    item_embed: PrismicEmbed;
  }>;
};

export const parse = (slice: Props, redirects): IStaggeredBlocks => ({
  type: SliceTypes.StaggeredBlocks,
  style: parser.string(slice.primary.slice_style),
  direction: parser.string(slice.primary.slice_direction),
  items: slice.fields.map((field) => ({
    image: parser.image(field.item_image),
    tagline: parser.string(field.item_tagline),
    title: parser.string(field.item_title),
    text: parser.richText(field.item_text),
    caption: parser.string(field.item_caption),
    label: parser.string(field.item_label),
    link: parser.link(field.item_link, redirects),
    secondLabel: parser.string(field.item_second_label),
    secondLink: parser.link(field.item_second_link, redirects),
    video: parser.link(field.item_video),
    embed: parser.embed(field.item_embed),
  })),
});
